'use client'
import React from 'react'
import { Company } from '../hooks/queries/useCompanies'
import { User } from '../hooks/queries/useUser'

const AuthContext = React.createContext<{
	loggedIn: boolean
	loading: boolean
	user: User | null
	company: Company | null
	setCompany: (company: Company) => void
	companies: Company[]
	isCompanyManager: boolean
	setCompanyName: (name: string) => void
}>({
	loggedIn: false,
	loading: true,
	user: null,
	company: null,
	setCompany: (company: Company) => {},
	companies: [],
	isCompanyManager: false,
	setCompanyName: (name: string) => {},
})

export default AuthContext
